/* Sportera - Connecte les fleches natives de la galerie produit (visibles sur l'image principale) */
/* au mecanisme natif Dawn media-gallery.setActiveMedia(), qui gere deja les miniatures. */
/* Portee stricte : galerie produit uniquement, desktop uniquement (>= 990px). Aucun nouveau slider. */
(function () {
  function wireGallery(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    var buttonsWrap = viewer.querySelector('.slider-buttons');
    if (!buttonsWrap) return;

    var prevBtn = buttonsWrap.querySelector('.slider-button--prev');
    var nextBtn = buttonsWrap.querySelector('.slider-button--next');
    if (!prevBtn && !nextBtn) return;

    if (prevBtn && prevBtn.dataset.spWired) return;
    if (nextBtn && nextBtn.dataset.spWired) return;

    function getItems() {
      return Array.prototype.slice.call(viewer.querySelectorAll('[data-media-id]'));
    }

    function getActiveIndex(items) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].classList.contains('is-active')) return i;
      }
      return -1;
    }

    function updateArrowState() {
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      var items = getItems();
      var index = getActiveIndex(items);
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= items.length - 1;
    }

    function goTo(offset) {
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      if (typeof gallery.setActiveMedia !== 'function') return;
      var items = getItems();
      var index = getActiveIndex(items);
      if (index === -1) return;
      var newIndex = index + offset;
      if (newIndex < 0 || newIndex >= items.length) return;
      gallery.setActiveMedia(items[newIndex].dataset.mediaId, false);
      updateArrowState();
    }

    if (prevBtn) {
      prevBtn.dataset.spWired = 'true';
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(-1);
      });
    }

    if (nextBtn) {
      nextBtn.dataset.spWired = 'true';
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(1);
      });
    }

    updateArrowState();
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(wireGallery);
  }

  if (window.customElements && customElements.get('media-gallery')) {
    init();
  } else if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('media-gallery').then(init).catch(init);
    window.setTimeout(init, 800);
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
